/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Adjustments_To_ConfirmInputs */

const en_queue_adjustments_to_confirm = /** @type {(inputs: Queue_Adjustments_To_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock adjustments to confirm`)
};

/**
* | output |
* | --- |
* | "Stock adjustments to confirm" |
*
* @param {Queue_Adjustments_To_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_adjustments_to_confirm = /** @type {((inputs?: Queue_Adjustments_To_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Adjustments_To_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_adjustments_to_confirm(inputs)
});